import { request, url } from "@frontend/lib/http";

type RequestOptions = { signal?: AbortSignal };

export type TimesheetFormat = "xls" | "pdf";

export const TIMESHEET_FORMATS: TimesheetFormat[] = ["xls", "pdf"];

export interface TimesheetPeriod {
  start: string;
  end: string;
}

export const timesheetApi = {
  async countPlannedEvents(
    employeeId: number,
    { start, end }: TimesheetPeriod,
    options: RequestOptions = {},
  ): Promise<number> {
    const { events } = await request<{ events: unknown[] }>({
      route: "ecopro_employee_planned_events",
      params: { employee: employeeId, start, stop: end },
      signal: options.signal,
    });

    return events.length;
  },

  downloadUrl(
    employeeId: number,
    { start, end }: TimesheetPeriod,
    format: TimesheetFormat,
  ): string {
    return url(
      "ecopro_employee_printschedule",
      { employees_option: employeeId, start, stop: end },
      { format },
    );
  },
};
